import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'

import { IMinimalCpmsResponse } from '@/apps/traforama/interfaces/dspMinimalCpms'

export const fetchItems = async (
  typeId: number
): Promise<IMinimalCpmsResponse> => {
  const params = Object.assign(
    { limit: 3000, start: 0 },
    nestedQueryFormatter('filter', { type_id: typeId }, false)
  )
  const response = await apiClient.get<IMinimalCpmsResponse>(
    '/dsp_minimal_cpms',
    { params: params }
  )
  return response.data
}
